var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationCancelled = function SvgTranslationCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F65050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.166 12a4.9 4.9 0 1 0 9.8 0 4.9 4.9 0 0 0-9.8 0Zm4.9-6.3a6.3 6.3 0 1 0 0 12.6 6.3 6.3 0 0 0 0-12.6ZM9.47 9.403a.7.7 0 0 1 .99 0l1.605 1.605 1.605-1.605a.7.7 0 1 1 .99.99L13.056 12l1.605 1.605a.7.7 0 0 1-.99.99l-1.605-1.605-1.605 1.605a.7.7 0 1 1-.99-.99L11.076 12 9.47 10.394a.7.7 0 0 1 0-.99Z",
    clipRule: "evenodd"
  })));
};
export default SvgTranslationCancelled;